import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull,
  get_currentSession2ignzypsmrqzv as get_currentSession,
  get_sessionTokenxwi299b0ks21 as get_sessionToken,
} from '../../sdk/currentSession.mjs';
import {
  ID2ebczrc12h07k as ID,
  User3mqs8plvl8nwo as User,
  UserRole_Admin_getInstance1ewshxr51h257 as UserRole_Admin_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LoginPage29d8dob2fd0ln as LoginPage } from '../LoginScreen.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name3aern4pcdmrjz as get_name,
  get_phoneph41zjp0zq4b as get_phone,
  get_preferredLanguage2fe7014lb3h3h as get_preferredLanguage,
  get__id1hi7gtah39onn as get__id,
  get__id1301miildb0kq as get__id_0,
  get__id2p9nbcwbj0zlw as get__id_1,
  get__id336i6k806byxy as get__id_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Employer27b20p5x27kte as Employer,
  CareProvider2qcawrqluyllr as CareProvider,
  CareLocation1v3u5wduz023s as CareLocation,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
} from '../components/view-utilities.mjs';
import {
  text189ciz0cnr32o as text,
  h2ld0l0a2c9zpb as h2,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  userForm5nk49durav10 as userForm,
  userPermissionskavzssr0zu9q as userPermissions,
} from './userComponents.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Switchrdgqp2jwylc6 as Switch } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Switch.commonHtml.mjs';
import { get_entriesmw6968mpe3hf as get_entries } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { _Name___get_raw__impl__1jq1il10anje4t2nwc9 as _Name___get_raw__impl__1jq1il } from '../../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/events/eventModels.mjs';
import { Companion_getInstance2ckxqlwfswrwh as Companion_getInstance_1 } from '../../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CHANNEL_COLUMN_WIDTH() {
  _init_properties_ProfilePage_kt__r1luzq();
  return CHANNEL_COLUMN_WIDTH;
}
var CHANNEL_COLUMN_WIDTH;
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ProfilePage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, ProfilePage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, ProfilePage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save user', VOID, VOID, VOID, VOID, VOID, ProfilePage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function ProfilePage$_get_title_$lambda_8tlq9u($this$remember) {
  return 'My profile';
}
function ProfilePage$user$lambda($this$Draft) {
  var session = $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull());
  var userId = session.userId_1;
  return $this$Draft.awaitNotNull_2lqt5h_k$(session.get_users_izsycf_k$().get_6ueaa7_k$(new (ID())(userId)));
}
function ProfilePage$availableNotificationSubscriptions$slambda() {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = yield* session.api_1.get_tCGNotifications_dv414p_k$().get_subscriptions_vnh9l9_k$().listEventSubscriptions_adwrwq_k$($completion);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$3;
      $l$block: {
        var tmp0_elvis_lhs = toNotificationType(element.subscription_1._id_1.event_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$3 = false;
          break $l$block;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var type = tmp;
        var tmp_0;
        switch (type.ordinal_1) {
          case 3:
          case 0:
          case 4:
          case 5:
            // Inline function 'com.lightningkite.reactive.context.invoke' call

            var this_1 = session.isAdmin_1;
            tmp_0 = yield* await_0(this_1, $completion);
            break;
          case 1:
          case 2:
            var tmp_1;
            // Inline function 'com.lightningkite.reactive.context.invoke' call

            var this_2 = session.managesProviders_1;
            if (yield* await_0(this_2, $completion)) {
              tmp_1 = true;
            } else {
              // Inline function 'com.lightningkite.reactive.context.invoke' call
              var this_3 = session.managesLocations_1;
              tmp_1 = yield* await_0(this_3, $completion);
            }

            tmp_0 = tmp_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp$ret$3 = tmp_0;
      }
      if (tmp$ret$3) {
        destination.add_utx5q5_k$(element);
      }
    }
    return destination;
  }), 1);
}
function ProfilePage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navSignOutTitle_jmnskh_k$();
}
function ProfilePage$render$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    try {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = get_currentSession();
      var tmp0_safe_receiver = yield* await_0(this_0, $completion);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.api_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_userAuth_yt6u3g_k$();
      if (tmp2_safe_receiver == null)
        null;
      else
        yield* tmp2_safe_receiver.terminateSession_ckz0qq_k$($completion);
    } catch ($p) {
      if ($p instanceof Exception()) {
        var _unused_var__etf5q3 = $p;
      } else {
        throw $p;
      }
    }
    finally {
      yield* get_sessionToken().set_revjhg_k$(null, $completion);
      get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (LoginPage())());
    }
    return Unit_instance;
  }), 0);
}
function ProfilePage$render$slambda_0() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSession();
    var tmp0_safe_receiver = yield* await_0(this_0, $completion);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.api_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      yield* tmp1_safe_receiver.resetSeedData_s2kgq5_k$($completion);
    return Unit_instance;
  }), 0);
}
function ProfilePage$render$lambda_0($this$invoke) {
  return 'Personal details';
}
function ProfilePage$render$lambda_1($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userEditIconDescription_a205ej_k$();
}
function ProfilePage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function ProfilePage$render$lambda_2($this$reactiveLabel) {
  return 'Name';
}
function ProfilePage$render$lambda_3($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userEmailLabel_3oltlg_k$();
}
function ProfilePage$render$lambda_4($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userPhoneLabel_fdgx22_k$();
}
function ProfilePage$render$lambda_5($this$reactiveLabel) {
  return 'Preferred language';
}
function ProfilePage$render$lambda_6($this$reactiveLabel) {
  return 'Status';
}
function ProfilePage$render$lambda_7($this$reactiveLabel) {
  return 'Created';
}
function ProfilePage$render$lambda_8($this$reactiveLabel) {
  return 'Last updated';
}
function ProfilePage$render$lambda_9($this$colOf, sub) {
  var type = lens(sub, ProfilePage$render$lambda$lambda);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$colOf.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$colOf.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_0 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = weight(this_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(type);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
    return tmp1_elvis_lhs == null ? 'Error' : tmp1_elvis_lhs;
  });
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  var tmp_2 = sizeConstraints(get_centered(element_0), VOID, VOID, VOID, VOID, VOID, get_CHANNEL_COLUMN_WIDTH());
  var tmp_3 = ProfilePage$render$lambda$lambda_0;
  channelSwitch(tmp_2, sub, tmp_3, ProfilePage$render$lambda$lambda_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  var this_2 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Separator())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_2.willAddChild_hz2iwc_k$(element_3);
  element_3.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $this$colOf.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function ProfilePage$render$lambda$lambda(it) {
  return toNotificationType(it.subscription_1._id_1.event_1);
}
function ProfilePage$render$lambda$lambda_0(it) {
  return it.email_1;
}
function ProfilePage$render$lambda$lambda_1(s, f) {
  return s.copy$default_hu5pe8_k$(VOID, f);
}
function ProfilePage$render$lambda_10($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function ProfilePage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function ProfilePage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.user_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function ProfilePage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudSaveButton_lsaoza_k$();
}
function ProfilePage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.user_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    var session = yield* await_0(this_1, $completion);
    var saved = yield* this$0.user_1.publish_xq9q2e_k$($completion);
    var tmp_0 = session.get_users_izsycf_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.user_1;
    var tmp$ret$3 = yield* await_0(this_2, $completion);
    var tmp_1 = tmp_0.get_6ueaa7_k$(new (ID())(tmp$ret$3._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_3 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$8 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$8);
    this_3.assign_vtsfu6_k$(get_name(it), saved.name_1);
    var tmp_3 = get_phone(it);
    var tmp_4 = saved.phone_1;
    this_3.assign_vtsfu6_k$(tmp_3, tmp_4 == null ? null : new (PhoneNumber())(tmp_4));
    this_3.assign_vtsfu6_k$(get_preferredLanguage(it), saved.preferredLanguage_1);
    var tmp$ret$4 = this_3.build_1k0s4u_k$();
    yield* tmp_1.modify_ff53f_k$(tmp$ret$4, $completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_5 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$10 = yield* await_1(this_4, $completion);
    toast(tmp_5, tmp$ret$10.get_crudSavedToast_xnj03d_k$());
    return Unit_instance;
  }), 1);
}
var ProfilePageClass;
function ProfilePage() {
  if (ProfilePageClass === VOID) {
    class $ extends Form() {
      constructor() {
        super();
        var tmp = this;
        tmp.user_1 = validated(Draft(ProfilePage$user$lambda));
        var tmp_0 = this;
        tmp_0.employers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = xDataClassPathInsideSet(get__id(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesEmployers_1);
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
        });
        var tmp_1 = this;
        tmp_1.providers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$13);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$14 = xDataClassPathInsideSet(get__id_0(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesProviders_1);
          var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
        });
        var tmp_2 = this;
        tmp_2.locations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$23);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp$ret$24 = xDataClassPathInsideSet(get__id_1(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesLocations_1);
          var tmp$ret$20 = new (Query())(tmp$ret$24, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$20));
        });
        var tmp_3 = this;
        tmp_3.families_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
          var tmp$ret$33 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$33);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
          var tmp$ret$37 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$37);
          var tmp$ret$34 = xDataClassPathInsideSet(get__id_2(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesFamilies_1);
          var tmp$ret$30 = new (Query())(tmp$ret$34, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$30));
        });
        var tmp_4 = this;
        tmp_4.availableNotificationSubscriptions_1 = rememberSuspending(VOID, true, VOID, ProfilePage$availableNotificationSubscriptions$slambda());
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ProfilePage$_get_title_$lambda_8tlq9u);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.user_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_4 = shownWhen(element_0, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_5 = themed(element_2, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_6 = themed(this_5, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Button())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_6.willAddChild_hz2iwc_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, ProfilePage$render$lambda);
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        onClick(element_3, VOID, VOID, VOID, ProfilePage$render$slambda(element_3));
        element_3.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_7 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.user_1.get_published_wg9pad_k$()).role_1.compareTo_30rs7w_k$(UserRole_Admin_getInstance()) >= 0);
        // Inline function 'com.lightningkite.kiteui.views.danger' call
        var this_8 = themed(this_7, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_9 = themed(this_8, DangerSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Button())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_9.willAddChild_hz2iwc_k$(element_5);
        text(element_5, 'Reset Seed Data');
        onClick(element_5, VOID, VOID, VOID, ProfilePage$render$slambda_0());
        element_5.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_5);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_10.willAddChild_hz2iwc_k$(element_6);
        element_6.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(element_6, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_11.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_7.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_12 = get_centered(element_8);
        var tmp$ret$46 = weight(this_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_13 = get_bold(tmp$ret$46);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_13.willAddChild_hz2iwc_k$(element_9);
        element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_7, ProfilePage$render$lambda_0);
        element_9.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_9);
        var tmp_8 = get_centered(element_8);
        var tmp_9 = get_edit(Companion_getInstance_0());
        var tmp_10 = ProfilePage$render$lambda_1;
        iconButton(tmp_8, tmp_9, tmp_10, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, ProfilePage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_8.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        element_7.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = weight(element_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_14.willAddChild_hz2iwc_k$(element_11);
        element_11.set_vertical_nuap32_k$(true);
        var tmp_11 = ProfilePage$render$lambda_2;
        reactiveLabel(element_11, tmp_11, ($this$reactiveLabel) => {
          var tmp;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).name_1;
          if (!isBlank(this_0)) {
            tmp = $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).name_1;
          } else {
            tmp = '[Not set]';
          }
          return tmp;
        });
        var tmp_12 = ProfilePage$render$lambda_3;
        reactiveLabel(element_11, tmp_12, ($this$reactiveLabel) => EmailAddress__toString_impl_artjh3($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).email_1));
        var tmp_13 = ProfilePage$render$lambda_4;
        reactiveLabel(element_11, tmp_13, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).phone_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        var tmp_14 = ProfilePage$render$lambda_5;
        reactiveLabel(element_11, tmp_14, ($this$reactiveLabel) => {
          var tmp;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).preferredLanguage_1;
          if (!isBlank(this_0)) {
            tmp = $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).preferredLanguage_1;
          } else {
            tmp = '[Not set]';
          }
          return tmp;
        });
        var tmp_15 = ProfilePage$render$lambda_6;
        reactiveLabel(element_11, tmp_15, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).active_1 ? 'Active' : 'Inactive');
        element_11.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Separator())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_10.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_15 = weight(element_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_15.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        var tmp_16 = ProfilePage$render$lambda_7;
        reactiveLabel(element_13, tmp_16, ($this$reactiveLabel) => renderToString($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).createdAt_1, RenderSize_Abbreviation_getInstance()));
        var tmp_17 = ProfilePage$render$lambda_8;
        reactiveLabel(element_13, tmp_17, ($this$reactiveLabel) => renderToString($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).updatedAt_1, RenderSize_Abbreviation_getInstance()));
        element_13.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_13);
        element_10.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_10);
        element_7.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_7);
        element_6.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_16 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_16.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Separator())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_14.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_15);
        actionBar(this, element_14);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$78 = themed(element_14, CardSemantic_getInstance());
        userForm(this, tmp$ret$78, this.user_1, false);
        actionBar(this, element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Separator())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_14.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_16);
        element_14.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_17.willAddChild_hz2iwc_k$(element_17);
        element_17.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_18 = themed(element_17, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_18.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_18.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_19 = themed(element_18, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (RowOrCol())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        this_19.willAddChild_hz2iwc_k$(element_19);
        element_19.set_vertical_nuap32_k$(true);
        h2(element_19, 'Email notification settings');
        subtext(element_19, 'Control which notifications you receive by email.');
        element_19.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_20 = shownWhen(element_18, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(this.availableNotificationSubscriptions_1).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (RowOrCol())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_20.willAddChild_hz2iwc_k$(element_20);
        element_20.set_vertical_nuap32_k$(true);
        colOf(element_20, this.availableNotificationSubscriptions_1, VOID, VOID, VOID, ProfilePage$render$lambda_9);
        element_20.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_20);
        element_18.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_18);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$100 = themed(element_17, CardSemantic_getInstance());
        userPermissions(tmp$ret$100, this.editMode_1, this.user_1, this.employers_1, this.providers_1, this.locations_1, this.families_1);
        element_17.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_21 = shownWhen(element, VOID, VOID, ProfilePage$render$lambda_10);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (Space())(this_21.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_21);
        this_21.willAddChild_hz2iwc_k$(element_21);
        element_21.onStartup_vrxh3i_k$();
        this_21.addChild_2qpft2_k$(element_21);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ProfilePage', ProfilePage, VOID, [Page(), CanBlockBack()]);
    ProfilePageClass = $;
  }
  return ProfilePageClass;
}
function channelSwitch(_this__u8e3s4, sub, channel, withChannel) {
  _init_properties_ProfilePage_kt__r1luzq();
  var tmp = remember(VOID, VOID, VOID, VOID, ($this$remember) => !(channel($this$remember.invoke_r7m7el_k$(sub).subscription_1) == null));
  var value = withWrite(tmp, channelSwitch$slambda(sub, channel, withChannel));
  // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Switch())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.bind_gesskf_k$(element.checked_1, value);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function toNotificationType(_this__u8e3s4) {
  _init_properties_ProfilePage_kt__r1luzq();
  var tmp0 = get_entries();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.eventName_ilcg5_k$() === _Name___get_raw__impl__1jq1il(_this__u8e3s4)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
}
function channelSwitch$slambda($sub, $channel, $withChannel) {
  return constructCallableReference(($this$withWrite, checked, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $sub;
    var subscription = (yield* await_0(this_0, $completion)).subscription_1;
    var new_0 = checked ? Companion_getInstance_1().immediately_trp1j6_k$() : null;
    var tmp;
    if (!equals($channel(subscription), new_0)) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_currentSessionNotNull();
      tmp = yield* (yield* await_0(this_1, $completion)).get_notificationSendMethods_n4dl6_k$().get_6ueaa7_k$(subscription._id_1).set_revjhg_k$($withChannel(subscription, new_0), $completion);
    }
    return Unit_instance;
  }), 2);
}
var properties_initialized_ProfilePage_kt_d9b708;
function _init_properties_ProfilePage_kt__r1luzq() {
  if (!properties_initialized_ProfilePage_kt_d9b708) {
    properties_initialized_ProfilePage_kt_d9b708 = true;
    CHANNEL_COLUMN_WIDTH = get_rem(4);
  }
}
//region block: exports
export {
  ProfilePage as ProfilePagezfg19fjwgylu,
};
//endregion

//# sourceMappingURL=ProfilePage.mjs.map
